module.exports = __webpack_public_path__ + "img/twitch.705c877f.svg";